/* Whitmore native cart drawer (replaces UpCart). Works on top of Impulse's theme.CartForm. */
(function () {
  'use strict';

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function removeLine(key, el) {
    if (el) el.closest('.cart__item') && el.closest('.cart__item').classList.add('is-loading');
    theme.cart.changeItem(key, 0).then(function (text) {
      var cart = null;
      try { cart = JSON.parse(text); } catch (e) {}
      rebuild(cart);
    });
  }

  document.addEventListener('click', function (evt) {
    var remove = evt.target.closest('[data-wm-remove]');
    if (remove) {
      evt.preventDefault();
      removeLine(remove.dataset.wmRemove, remove);
      return;
    }

    // Impulse ignores quantity 0, so "−" at 1 would do nothing. Remove the line instead.
    var minus = evt.target.closest('[data-wm-minus]');
    if (minus) {
      var input = minus.parentNode.querySelector('.js-qty__num');
      if (input && parseInt(input.value, 10) <= 1) {
        evt.stopImmediatePropagation();
        removeLine(minus.dataset.wmMinus, minus);
      }
      return;
    }

    var add = evt.target.closest('[data-wm-rec-add]');
    if (add) {
      var select = add.parentNode.querySelector('.wm-rec__select');
      if (!select || !select.value) return;
      add.disabled = true;
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(select.value), quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function (res) {
        add.disabled = false;
        if (res && res.status) { alert(res.description || res.message); return; }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
      }).catch(function () { add.disabled = false; });
    }
  }, true);

  // The drawer markup is replaced on every cart change: sync the header count
  // and slide the tier bar from its previous width.
  var lastFill = null;
  function sync(container) {
    var items = container.querySelector('.cart__items');
    if (!items) return;
    document.querySelectorAll('[data-wm-count]').forEach(function (el) { el.textContent = items.dataset.count; });

    var fill = container.querySelector('.wm-rewards__fill');
    if (!fill) return;
    var target = fill.style.width;
    if (lastFill !== null && lastFill !== target) {
      fill.style.transition = 'none';
      fill.style.width = lastFill;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = target;
    }
    lastFill = target;
  }

  function init() {
    document.querySelectorAll('#CartDrawer [data-products]').forEach(function (container) {
      new MutationObserver(function () { sync(container); }).observe(container, { childList: true });
      sync(container);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
